export default [ 
  {
    group: "/resumen",
    model: false,
    icon: "mdi mdi-file",
    title: "CMI",
    to: "/cmi",
  }, 
  {
    group: "/indicadores",
    model: false,
    icon: "mdi mdi-file",
    title: "Indicadores",
    to: "/indicadores",
  }, 
  {
    group: "/monitoreo",
    model: false,
    icon: "mdi mdi-file",
    title: "Monitoreo",
    to: "/monitoreo",
  }, 
  {
    group: "/medicamentos",
    model: false,
    icon: "mdi mdi-file",
    title: "Medicamentos",
    to: "/medicamentos",
  }, 
];
